import { LEAD_STATUS } from "./enums";
import { LEAD_STATUS_LABELS } from "./labels";

export const SELECTABLE_LEAD_STATUSES = [
  LEAD_STATUS.NEW,
  LEAD_STATUS.QUALIFYING,
  LEAD_STATUS.CONTACTED,
];

function isKnownLeadStatus(value) {
  return Object.values(LEAD_STATUS).includes(value);
}

function toOption(status, { disabled = false } = {}) {
  return {
    value: status,
    label: LEAD_STATUS_LABELS[status]?.de || status,
    disabled,
  };
}

export function getSelectableLeadStatuses() {
  return [...SELECTABLE_LEAD_STATUSES];
}

export function getLeadStatusFilterOptions() {
  return SELECTABLE_LEAD_STATUSES.map((s) => toOption(s));
}

export function getLeadStatusOptionsForCurrentStatus(currentStatus) {
  const options = SELECTABLE_LEAD_STATUSES.map((s) => toOption(s));
  if (
    currentStatus &&
    isKnownLeadStatus(currentStatus) &&
    !SELECTABLE_LEAD_STATUSES.includes(currentStatus)
  ) {
    options.unshift(toOption(currentStatus, { disabled: true }));
  }
  return options;
}

